import { render, staticRenderFns } from "./rotationClassification.vue?vue&type=template&id=21757b85&scoped=true&"
import script from "./rotationClassification.vue?vue&type=script&lang=js&"
export * from "./rotationClassification.vue?vue&type=script&lang=js&"
import style0 from "./rotationClassification.vue?vue&type=style&index=0&id=21757b85&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21757b85",
  null
  
)

export default component.exports